import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendSubmitCsatSurvey, sendSubmitCsatSurveyLegacy } from '../api/csatSurveyApi';
export const submitCsatSurvey = createAsyncThunk('chat/submitCsatSurvey', async ({
  score,
  text,
  threadId
}) => await sendSubmitCsatSurvey({
  score,
  text,
  threadId
}));

// Legacy Actions

export const submitCsatSurveyLegacy = createAsyncThunk('chat/submitCsatSurveyLegacy', async ({
  score,
  text,
  threadId
}) => await sendSubmitCsatSurveyLegacy({
  score,
  text,
  threadId
}));